import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function WDepartment() {
  const dispatch = useDispatch();
  /*   ALL STATES
   ********************************************* */

  const [departmentList, setDepartmentList] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  //get Data
  const getDepartmentList = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/manufacturer/wages/departments", {
        headers: authHeader(),
      });
      if (data?.success) {
        setDepartmentList(data?.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete Quotations
  const deleteDepartment = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete(
        "/manufacturer/wages/department/" + id,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setDepartmentList((prev) => prev.filter((item) => item.id !== id));
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Adds Button Function
  const AddDepartment = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post(
        "/manufacturer/wages/department",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setDepartmentList((prev) => [...prev, data?.data]);
        setFormData({});
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }

    setShowAddModal(false);
  };

  // Update Button Function
  const UpdateDepartment = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch(
        "/manufacturer/wages/department/",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setDepartmentList((prev) => {
          const newData = prev.map((item) => {
            if (item.id === formData.id) {
              return data?.data;
            }
            return item;
          });
          return newData;
        });
        setIsUpdateMode(false);
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Sorting Up
  const sortUp = async (id) => {
    const index = departmentList.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === 0) return;
    if (index === departmentList.length) return;

    const currentSortId = departmentList[index]?.sortId;
    const currentId = departmentList[index]?.id;
    const upSortId = departmentList[index - 1].sortId;
    const upId = departmentList[index - 1].id;
    try {
      const { data } = await API.post(
        "/manufacturer/wages/department/sort-up",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getDepartmentList();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortDown = async (id) => {
    const index = departmentList.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === departmentList.length - 1) return;

    const currentSortId = departmentList[index]?.sortId;
    const currentId = departmentList[index]?.id;
    const downSortId = departmentList[index + 1].sortId;
    const downId = departmentList[index + 1].id;

    try {
      const { data } = await API.post(
        "/manufacturer/wages/department/sort-down",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getDepartmentList();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      getDepartmentList();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        <button
          onClick={() => {
            setShowAddModal(true);
            setFormData({});
            setIsUpdateMode(false);
          }}
          type="button"
          className="btn btn-primary  ms-1"
        >
          Add Department
        </button>
      </>
    </div>
  );

  const table_head = ["ID", "Department Name", "Actions"];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="align-middle py-1">{item.departmentId}</td>
      <td className="align-middle py-1">{item.departmentName}</td>
      <td className="table-action align-middle py-1">
        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn py-0 px-1"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        <button
          onClick={() => {
            item.sort_id !== 1 && sortUp(item?.id);
          }}
          disabled={item.sort_id === 1}
          className="btn btn-sm btn-outline-secondary"
        >
          <i className="mdi mdi-chevron-double-up"></i>
        </button>
        <button
          onClick={() => {
            item.sort_id !== departmentList.length && sortDown(item?.id);
          }}
          disabled={item.sort_id === departmentList.length}
          className="btn btn-sm btn-outline-secondary"
        >
          <i className="mdi mdi-chevron-double-down"></i>
        </button>

        <DeleteModalButton
          btnClass={"btn py-0 px-1"}
          deleteFunc={deleteDepartment}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  return (
    <div className="">
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div
        className="px-2 flex-grow-1 d-flex"
        style={{ height: "79vh", overflowY: "auto" }}
      >
        <div className="horizontal-scrollable d-flex flex-grow-1">
          <Table
            btn1={btn1}
            table_head={table_head}
            table_body={table_body}
            table_data={departmentList}
          />
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <div className="">
            <h4>{isUpdateMode ? "Update Department" : "Add Department"}</h4>
          </div>
          <hr className="mt-0" />
          <form
            onSubmit={isUpdateMode ? UpdateDepartment : AddDepartment}
            className=""
          >
            <div className="mb-1">
              <label className="">Department Name</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.departmentName || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      departmentName: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter department Name"
                />
              </div>
            </div>

            {/*   buttons
             ********************************************* */}
            <div className="mt-3">
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    setShowAddModal(false);
                  }}
                  className="btn btn-secondary btn-sm"
                  type="button"
                >
                  Close
                </button>
                <button
                  disabled={loading}
                  className="btn btn-primary btn-sm ms-1"
                  type="submit"
                >
                  {isUpdateMode ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
